import { createSpinnerMaterial } from '@subaio/components'

const MaterialSpinner = createSpinnerMaterial(({ theme }) => ({
	color: theme.color.headerIconPrimaryAccent,
	size: 64,
}))

export const Spinner = () => <MaterialSpinner />
